// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"192":"dda850f4dc8df768244b","339":"0b5f7b5590f3752dada7","361":"c835699cfee27bb54dc5","706":"9b3a7e843e99ff7a1e76","720":"3f174b01c0e679d73945"}[chunkId] + ".min.js";
};